import { GridColDef } from '@mui/x-data-grid'
import { Link } from 'react-router-dom'

import { OrganizationUser } from '../../api/organization/types'
import { OrganizationAttributionSummary } from '../../api/attribution/types'
import { Bundle } from '../../api/bundle/types';
import { OrganizationLink } from '../../api/links/types';

export const organizationUsersColumns: GridColDef<OrganizationUser>[] = [
    {
        field: 'firstName',
        headerName: 'First Name',
        width: 300,
        editable: false,
    },
    {
        field: 'lastName',
        headerName: 'Last Name',
        width: 300,
        editable: false,
    },
    {
        field: 'email',
        headerName: 'Email',
        width: 300,
        editable: false,
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 150,
        editable: false,
    },
];

export const organizationLinksColumns: GridColDef<OrganizationLink>[] = [
    {
        field: 'displayName',
        headerName: 'Name',
        width: 300,
        editable: false,
    },
    {
        field: 'url',
        headerName: 'URL',
        width: 400,
        editable: false,
        renderCell: (cellValues) => {
            const linkUrl = `https://sp.viubyhub.com/link/${cellValues.row.linkGuid}`;
            return (
                <a href={linkUrl} target="_blank" rel="noopener noreferrer">
                    {linkUrl}
                </a>
            );
        },
    },
    {
        field: 'bundleDisplayName',
        headerName: 'Bundle',
        width: 200,
        editable: false,
        renderCell: (cellValues) => {
            return <span>{cellValues.row.bundleName || 'No Bundle'}</span>;
        },
    },
    {
        field: 'edit',
        headerName: 'Edit',
        width: 100,
        editable: false,
        renderCell: (cellValues) => {
            return <Link to={`/organization/${cellValues.row.organizationGuid}/links/${cellValues.row.linkGuid}`}>Edit</Link>
        }
    },
];

export const organizationAttributionColumns: GridColDef<OrganizationAttributionSummary>[] = [
    {
        field: 'displayName',
        headerName: 'Name',
        width: 300,
        editable: false,
    },
    {
        field: 'type',
        headerName: 'Type',
        width: 200,
        editable: false,
    },
    {
        field: 'required',
        headerName: 'Required',
        width: 100,
        editable: false,
    },
    {
        field: 'editLink',
        headerName: 'Edit',
        width: 100,
        editable: false,
        renderCell: (cellValues) => {
            return <Link to={`/attribution/${cellValues.row.attributionGuid}`}>Edit</Link>;
        }
    },
];

export const bundleColumns: GridColDef<Bundle>[] = [
    {
        field: 'displayName',
        headerName: 'Name',
        width: 300,
        editable: false,
        renderCell: (cellValues) => {
            return <span>{cellValues.row.displayName || 'No Bundles'}</span>;
        },

    },
    {
        field: 'edit',
        headerName: 'Edit',
        width: 100,
        editable: false,
        renderCell: (cellValues) => <Link to={`/organization/${cellValues.row.organizationGuid}/bundles/${cellValues.row.bundleGuid}`}>Edit</Link>
        
    },
];


export const quoteExperienceColumns: GridColDef<Bundle>[] = [
    {
        field: 'displayName',
        headerName: 'Name',
        width: 300,
        editable: false,
        renderCell: (cellValues) => {
            return <span>{cellValues.row.displayName || 'No Quote Experiences'}</span>;
        },

    },
    {
        field: 'edit',
        headerName: 'Edit',
        width: 100,
        editable: false,
        renderCell: (cellValues) => <Link to={`/organization/${cellValues.row.organizationGuid}/quote-experience/${cellValues.row.bundleGuid}`}>Edit</Link>
        
    },
];